import { useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { RolePermission, useCreateRole, useRoleDetail } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';
import { getErrorMessage } from '../apiHelper';

function CloneRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [createRole, { loading: cloning }] = useCreateRole();
	const { t } = useTranslation();
	const { setToastInfo } = useDashboardContext();
	const initialValues = useMemo(() => {
		if (!role) {
			return undefined;
		}
		return {
			roleId: role.id,
			roleName: `${role.role} clone`,
			description: role.description,
			sourceRoleName: role.role,
			permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? [],
		};
	}, [role]);
	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			if (role?.role === values.roleName) {
				setToastInfo?.({
					message: t('errorCodes.customRolesDuplicationName'),
					type: 'warning',
					icon: 'campaignInfo',
				});
				return
			}
			await createRole(values);
			setToastInfo?.({
  				message: t('notification.clone.success', { name: 'Role' }),
				type: 'success',
				icon: 'check',
			});
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			const message = getErrorMessage(error, t("errorCodes.genericErrorMessage"));
			setToastInfo?.({
				message: message,
				type: 'warning',
				icon: 'campaignInfo',
			});
		}
	};

	if (loading || !role || !initialValues) return <Spin />;
	return (
		<>
			<PermissionList
				mode="clone"
				permissionList={permissionList}
				initialValues={initialValues}
				loading={cloning}
				onCancel={() => history.goBack()}
				onSubmit={handleSubmit}
			/>

		</>

	);
}

export default CloneRole;